export default __webpack_public_path__ + "static/daf794f4f44c3df04ab11169fe3cbf50.svg";